(function ($, Drupal, once) {
  "use strict";

  const drupalAjaxDone = new Event("drupalAjaxDone");
  $(document).ajaxComplete(function(event, xhr, settings) {
    document.dispatchEvent(drupalAjaxDone);
  });

})(jQuery, Drupal, once);
